import { connect } from '../../../common/components/runtime-context';
import Avatar from '../../components/avatar';
import { getCurrentUser } from '../../../common/store/current-user/current-user-selectors';

const mapRuntimeToProps = state => ({
  user: getCurrentUser(state),
});

export default connect(mapRuntimeToProps)(Avatar);
